<template>
  <section class="sponsors general">
    <div class="sponsors__content">
      <h1 class="sponsors__title">
          Presenting Companies
      </h1>
      <div class="sponsors__logos">
        <template v-for="partner in partners" :key="partner.name">
          <a v-if="partner.url" :href="partner.url" target="_blank">
            <div
              class="sponsors__item single smaller"
            >
              <div class="sponsors__logo-container nobg">
                <img :src="partner.logo" :alt="partner.name" :class="partner.class || 'full-logo'">
              </div>
            </div>
          </a>
          <div
            v-else
            class="sponsors__item single smaller"
          >
            <div class="sponsors__logo-container nobg">
              <img :src="partner.logo" :alt="partner.name" :class="partner.class || 'full-logo'">
            </div>
          </div>
        </template>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
@import '@/styles/components/sponsors.scss';
</style>

<script>
import { ref } from 'vue';

export default {
  setup() {
    const partners = ref([
    { logo: require('@/assets/logos/wirenetwork.svg'), class: 'full-logo', name: 'Wire Network', url: 'https://www.wire.network/' },
      { logo: require('@/assets/logos/polymath.svg'), class: 'full-logo', name: 'Polymath', url: 'https://www.polymath.network/' },
      { logo: require('@/assets/logos/spacecoin.png'), class: 'full-logo', name: 'Spacecoin', url: 'https://spacecoin.org/' },
      { logo: require('@/assets/logos/midnight.svg'), class: 'full-logo', name: 'Midnight', url: 'https://midnight.network/' },
      { logo: require('@/assets/logos/zeebu.png'), class: 'full-logo', name: 'Zeebu', url: 'http://zeebu.com/' },
      { logo: require('@/assets/logos/kraken.webp'), class: 'full-logo', name: 'Kraken', url: 'https://www.kraken.com/' },
      { logo: require('@/assets/logos/skybridge.svg'), class: 'full-logo', name: 'Skybridge', url: 'https://www.skybridge.com/' },
      { logo: require('@/assets/logos/bittensor.svg'), class: 'full-logo', name: 'Bittensor', url: 'https://www.bittensor.ai/subnets/17' },
      { logo: require('@/assets/logos/backstage.svg'), class: 'full-logo', name: 'Backstage', url: 'https://backstage.global/' },
      { logo: require('@/assets/logos/contango.svg'), class: 'full-logo', name: 'Contango', url: 'https://www.contango.digital/' },
      { logo: require('@/assets/logos/alpha.svg'), class: 'full-logo', name: 'Alpha Transform', url: 'https://alphatransform.co/' },
      { logo: require('@/assets/logos/polymesh.svg'), class: 'full-logo', name: 'Polymesh', url: 'https://polymesh.network/' },
      { logo: require('@/assets/logos/lifted.png'), class: 'full-logo', name: 'Lifted Initiative', url: 'https://liftedinit.org/' },
      { logo: require('@/assets/logos/manifest.png'), class: 'full-logo', name: 'Manifest', url: 'https://manifestai.org/' },
      { logo: require('@/assets/logos/cse.png'), class: 'full-logo', name: 'Canadian Securities Exchange', url: 'https://thecse.com/' },
      { logo: require('@/assets/logos/milborne.svg'), class: 'logo ibc', name: 'Milborne Group', url: 'https://milborne.com/' },
      { logo: require('@/assets/logos/morpheus.svg'), class: 'logo', name: 'Morpheus', url: 'https://mor.org/' },
      { logo: require('@/assets/logos/contentquo.svg'), class: 'full-logo', name: 'ContentQuo', url: 'https://www.contentquo.com/' },
      { logo: require('@/assets/logos/dayone.svg'), class: 'full-logo', name: 'Day One Law', url: 'https://www.dayonelaw.xyz/' },
      { logo: require('@/assets/logos/blg.svg'), class: 'full-logo', name: 'BLG LLC', url: 'https://www.blg.com/' },
      { logo: require('@/assets/logos/renno.svg'), class: 'logo ibc', name: 'Renno & Co', url: 'https://www.rennoco.com/' },
      { logo: require('@/assets/logos/raiinmaker.png'), class: 'full-logo', name: 'Raiinmaker', url: 'https://www.raiinmaker.com/' },
      { logo: require('@/assets/logos/pentagon.png'), class: 'full-logo', name: 'Pentagon Games', url: 'https://pentagon.games/' },
      { logo: require('@/assets/korea/sponsors/wow.webp'), class: 'logo', name: 'WOW!?', url: 'https://wow.ai/' },
      { logo: require('@/assets/nashville/sponsors/kredete.png'), class: 'full-logo', name: 'Kredete', url: 'https://www.kredete.com/' },
      { logo: require('@/assets/singapore/sponsors/bos.png'), class: 'logo', name: 'BitcoinOS', url: 'https://www.bitcoinos.build/' },
      { logo: require('@/assets/logos/pact.png'), class: 'logo', name: 'Pact Swap', url: 'https://pactswap.io/' },
      { logo: require('@/assets/nashville/sponsors/chintai.png'), class: 'full-logo', name: 'Chintai', url: 'https://chintai.io/' }
    ]);
    return {
      partners
    };
  },
};
</script>